import React, { useState, useEffect } from 'react';
import AliceCarousel from 'react-alice-carousel';

import { OpenQuote, CloseQuote } from '../Icons';
import { Grid } from '@husslehq/ui-library';

import { Testimonial } from './Testimonial';

import styles from './Testimonials.module.scss';

export type TestimonialsProps = {
  testimonials: Testimonial[];
};

export const Testimonials: React.FC<TestimonialsProps> = ({ testimonials }) => {
  const [responsive, setResponsive] = useState({});
  const items = testimonials.map((item, index) => <Testimonial key={index} testimonial={item} />);

  // responsive layout needs to be stored in state for the alice carousel
  // plugin to render the items correctly when using the infinite prop
  useEffect(() => {
    const responsiveLayout = {
      0: { items: 1 },
      767: { items: 1 },
      1199: { items: 1 },
    };

    setResponsive(responsiveLayout);
  }, []);

  return (
    <section className={styles.testimonials}>
      <Grid>
        <div className={styles.testimonials__wrapper}>
          <div className={styles.testimonials__openquote}>
            <OpenQuote />
          </div>
          <AliceCarousel
            disableButtonsControls
            autoPlayInterval={10000}
            autoPlay
            responsive={responsive}
            mouseTracking
            items={items}
            infinite
            controlsStrategy="alternate"
          />
          <div className={styles.testimonials__closequote}>
            <CloseQuote />
          </div>
        </div>
      </Grid>
    </section>
  );
};
